// src/components/ManagementView.js
import React, { useEffect, useState } from 'react';
import PlayersView from './PlayersView';
import TeamView from './TeamView';
import { fetchJson } from '../utils/api';

function ManagementView() {
    const [teams, setTeams] = useState([]);
    const [players, setPlayers] = useState([]);

    // Teams aus dem Backend laden
    const fetchTeams = () => {
        console.log('[ManagementView] Starte fetchTeams()...');
        fetchJson('/api/teams')
            .then((data) => {
                console.log('[ManagementView] Empfange Teams:', data);
                setTeams(data);
            })
            .catch((err) => console.error('[ManagementView] Fehler bei fetchTeams:', err));
    };

    // Players aus dem Backend laden
    const fetchPlayers = () => {
        console.log('[ManagementView] Starte fetchPlayers()...');
        fetchJson('/api/players')
            .then((data) => {
                console.log('[ManagementView] Empfange Players:', data);
                setPlayers(data);
            })
            .catch((err) => console.error('[ManagementView] Fehler bei fetchPlayers:', err));
    };

    useEffect(() => {
        console.log('[ManagementView] useEffect [] -> fetchTeams & fetchPlayers');
        fetchTeams();
        fetchPlayers();
    }, []);

    // Wird von PlayersView aufgerufen, wenn sich Player- oder Teamdaten ändern
    const onPlayersChanged = () => {
        console.log('[ManagementView] onPlayersChanged() -> erneutes Laden');
        fetchPlayers();
        fetchTeams();
    };

    // Wird von TeamView aufgerufen, wenn sich Teams ändern
    const onTeamsChanged = () => {
        console.log('[ManagementView] onTeamsChanged() -> erneutes Laden');
        fetchTeams();
        fetchPlayers();
    };

    return (
        <div className="page section-stack">
            <div className="card">
                <div className="card-header">
                    <h2 className="card-title">Spieler &amp; Teams</h2>
                    <span className="text-muted">Verwalte Zuordnungen und Punkte</span>
                </div>
                <div className="responsive-split">
                    <div className="card" style={{ margin: 0 }}>
                        <PlayersView
                            teams={teams}
                            players={players}
                            onPlayersChanged={onPlayersChanged}
                        />
                    </div>
                    <div className="card" style={{ margin: 0 }}>
                        <TeamView
                            teams={teams}
                            onTeamsChanged={onTeamsChanged}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ManagementView;